import React from "react";
import {logAction} from "../../../../logging/logEvent";
import PortfolioCheckbox from "./PortfolioCheckbox";

const ClosePortfolioCheckbox = ({portfolio, closing, ideaActions}) => {
    const isSelected = closing.selectedBucketIds.includes(portfolio.bucketId);
    const onClick = () => {
        const include = !isSelected;
        logAction({
            type: "CLOSE_PORTFOLIO_CHECKBOX_CLICKED",
            bucketId: portfolio.bucketId,
            portfolioName: portfolio.name,
            newValue: include
        });
        ideaActions.updateBucketIdToClose(portfolio.bucketId, include);
    };

    return (<PortfolioCheckbox className="t-select-to-close-checkbox"
                               onClick={onClick}
                               checked={isSelected}/>);
};

export default ClosePortfolioCheckbox;